export default "__VITE_ASSET__W01n9aVH__"